import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import SupplierWithItemReportModal from "../components/supplierWithItemReportModal";
import Time from "../components/time";
import { useParams, useNavigate, Link } from "react-router-dom";
import Swal from "sweetalert2";

// ⭐ Visual Star Rating UI
const StarRating = ({ percentage }) => {
     useAuthRedirect();
    const rating = Math.round((percentage / 100) * 5);
    const fullStars = "★".repeat(rating);
    const emptyStars = "☆".repeat(5 - rating);
    const color =
        percentage >= 90
            ? "#4CAF50"
            : percentage >= 70
            ? "#FFC107"
            : "#F44336";

    return (
        <div style={{ display: "flex", alignItems: "center" }}>
            <div
                style={{
                    width: "100px",
                    background: "#eee",
                    borderRadius: "5px",
                    marginRight: "8px",
                    overflow: "hidden",
                }}
            >
                <div
                    style={{
                        width: `${percentage}%`,
                        backgroundColor: color,
                        height: "10px",
                    }}
                />
            </div>
            <span style={{ fontSize: "1.2em", color }}>{fullStars + emptyStars}</span>
        </div>
    );
};

const DeliveryRating = () => {
    const [showModal, setShowModal] = useState(false);
    const [selectedItems, setSelectedItems] = useState([]);
    const branch = localStorage.getItem("branch");
    const user = localStorage.getItem("username");
    const [sCode, setScode] = useState(null);
    const [sName, setSName] = useState(null);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    const handleSelectItem = async (supplier) => {
        try {
            setScode(supplier.supplierMaster_code);
            setSName(supplier.supplierMaster_name);

            const response = await axios.get("https://rfs2.infraconsoft.net.in/api/vendorRating_delivery", {
                params: {
                    sCode: supplier.supplierMaster_code,
                    branch: branch,
                },
            });

            if (response.data.purchaseOrderList.length > 0) {
                setSelectedItems(response.data.purchaseOrderList);
            }
        } catch (error) {
            console.error("Error fetching supplier items:", error);
        }
    };

    useEffect(() => {
        if (sCode) {
            fetchData();
        }
    }, [sCode, branch]);

    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await axios.get(
                `https://rfs2.infraconsoft.net.in/api/vendorRating_delivery1?sCode=${sCode}&branch=${branch}`
            );
            setData(response.data.purchaseOrderList1);
        } catch (error) {
            console.error("Error fetching itemList:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div id="admin-container">
            <InventoryNav />
            <div className="content-right">
                <section>
                    <div className="back-div">
                        <h2 className="add-txt">Supplier With Item - Report</h2>
                        <Link to="/inventory/vendorControlRatingMenu">
                            <p className="back-button">
                                <i className="fa-solid fa-backward"></i> Back
                            </p>
                        </Link>
                    </div>
                    <Time />
                </section>

                <div className="form-container">
                    <form className="vehicle-form">
                        <div className="form-row">
                            <div className="form-group">
                                <label>Supplier Code :</label>
                                <input type="text" value={sCode || ""} readOnly />
                            </div>
                            <div className="form-group">
                                <label>Supplier Name :</label>
                                <input type="text" value={sName || ""} readOnly />
                            </div>
                        </div>

                        <div className="flex_buttons">
                            <button
                                type="button"
                                className="button button-add"
                                onClick={() => setShowModal(true)}
                            >
                                Select Supplier
                            </button>
                        </div>

                        {/* Summary Table with DR% */}
                        <div className="content-table">
                            <table>
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Supplier Code</th>
                                        <th>Supplier Name</th>
                                        <th>DR%</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {selectedItems.length > 0 ? (
                                        selectedItems.map((item, index) => {
                                            const pDate = new Date(item.first_po_date);
                                            const grnDate = new Date(item.first_grn_date);
                                            const totalOrdered = item.total_ordered_quantity || 0;
                                            const packedQty = item.total_packed_quantity || 0;

                                            let mD1 = 0;
                                            let mD2 = 0;
                                            const dateDiff = (grnDate - pDate) / (1000 * 60 * 60 * 24);

                                            if (pDate <= grnDate) {
                                                mD1 = packedQty;
                                            }
                                            if (dateDiff > 0 && dateDiff <= 7) {
                                                mD2 = packedQty;
                                            }

                                            const deliveryRating =
                                                totalOrdered > 0
                                                    ? Math.min(100, ((mD1 + 0.5 * mD2) * 100) / totalOrdered)
                                                    : 0;

                                            return (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{item.grnheader_suppliercode}</td>
                                                    <td>{item.suppliermaster_name}</td>
                                                    <td>
                                                        <StarRating percentage={deliveryRating.toFixed(2)} />
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan="4">No Items</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        {/* Detailed Table */}
                        <div className="content-table">
                            <table>
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Grn No</th>
                                        <th>Date</th>
                                        <th>P.O No.</th>
                                        <th>Schd Dt.</th>
                                        <th>Item</th>
                                        <th>Name</th>
                                        <th>UOM</th>
                                        <th>Ordered Qty</th>
                                        <th>Within Date</th>
                                        <th>7 Days Delay</th>
                                        <th>After 7 Days</th>
                                        <th>DR %</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.length > 0 ? (
                                        data.map((item, index) => {
                                            const mD = item.purchaseOrderSchedule_quantity ?? 0;
                                            let mD1 = 0,
                                                mD2 = 0,
                                                mAfter7 = 0;

                                            const poDate = item.purchaseOrderSchedule_date
                                                ? new Date(item.purchaseOrderSchedule_date)
                                                : null;
                                            const grnDate = item.grnheader_date
                                                ? new Date(item.grnheader_date)
                                                : null;

                                            let daysDiff = 0;
                                            if (poDate && grnDate) {
                                                daysDiff = Math.floor(
                                                    (grnDate - poDate) / (1000 * 60 * 60 * 24)
                                                );
                                            }

                                            if (daysDiff >= 0) {
                                                mD1 = item.grnSchedule_PackedQuantity ?? 0;
                                            }
                                            if (daysDiff > 0 && daysDiff <= 7) {
                                                mD2 = item.grnSchedule_PackedQuantity ?? 0;
                                            }
                                            if (daysDiff > 7) {
                                                mAfter7 = item.grnSchedule_PackedQuantity ?? 0;
                                            }

                                            const mDeliveryRating =
                                                mD > 0 ? ((mD1 + 0.5 * mD2) * 100) / mD : 0;

                                            return (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{item.grnheader_number}</td>
                                                    <td>{grnDate?.toLocaleDateString() || "N/A"}</td>
                                                    <td>{item.purchaseOrderSchedule_poNumber}</td>
                                                    <td>{poDate?.toLocaleDateString() || "N/A"}</td>
                                                    <td>{item.purchaseOrderSchedule_itemCode}</td>
                                                    <td>{item.itemmaster_name}</td>
                                                    <td>{item.itemmaster_uom}</td>
                                                    <td>{mD}</td>
                                                    <td>{mD1}</td>
                                                    <td>{mD2}</td>
                                                    <td>{mAfter7}</td>
                                                    <td>{mDeliveryRating.toFixed(2)}%</td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan="13">No Items</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </form>
                </div>
            </div>

            <SupplierWithItemReportModal
                showModal={showModal}
                closeModal={() => setShowModal(false)}
                branch={branch}
                onSelectItem={handleSelectItem}
            />
        </div>
    );
};

export default DeliveryRating;
